import { Component } from '@angular/core';
import { MODAL_ROUTES } from '@woolworthsnz/shop';
import { SlottedModalComponent, RoutedModalBaseComponent } from '@woolworthsnz/styleguide';
import { DeliveryAddressSelectionComponent } from '@woolworthsnz/fulfilment';

@Component({
	selector: 'wnz-change-delivery-address-modal',
	templateUrl: './change-delivery-address-modal.component.html',
	standalone: true,
	imports: [SlottedModalComponent, DeliveryAddressSelectionComponent],
})
export class ChangeDeliveryAddressModalComponent extends RoutedModalBaseComponent {
	modalRoutes = MODAL_ROUTES;
}
